import { Box } from '@mui/material';

const SubHeader = ({title}:{title:string}) => {
  const headerColumns = [
    { label1: 'Snte', label2: 'Oui/Non' ,color:"#0099F2" },
    { label1: 'Valeur', label2: 'début' ,color : "#28B66F" },
    { label1: 'Valeur', label2: 'cible' ,color : "#28B66F" },
    { label1: 'fin 24', },
    { label1: 'fin 25', },
    { label1: 'mi 26', },
    { label1: 'fin 26', },
    { label1: 'mi 27', },
    { label1: 'fin 27', },
    { label1: 'mi 28', },
    { label1: 'fin 28', },
    { label1: 'mi 29', },
    { label1: 'fin 29', },
    { label1: ''}
  ];

  return (
    <Box
      sx={{
        width: '100% !important',
        backgroundColor: '#f3f6f8',
      }}
      className="border-b-2 w-full h-[50px] text-[#637381] flex items-center"
    >
      <div className="w-[50px] min-w-[50px] h-full flex items-center justify-center text-xs capitalize">
      N° indicat.
      </div>
      <div className="w-[270px] min-w-[270px] h-full flex items-center justify-center text-xs capitalize">
        Indicateur {title}
      </div>
      <div className="flex flex-grow h-full">
        {headerColumns.map((column, index) => (
          <div 
            key={index} 
            className={`flex-grow   text-thin text-xs flex items-center justify-center flex-col capitalize  ${index === headerColumns.length - 1 ? 'border-r-0' : ''}`}
           style={{
            color : column.color ? column.color : ""
           }}
           >
            <span>{column.label1}</span>
            <span>{column.label2 || ""}</span>
          </div>
        ))}
      </div>
    </Box>
  );
};

export default SubHeader;
